<div class="card--hidden" rte="1li">
    <h1 rte="1lj">Database Column Types</h1>
    <span class="page-sub-header" rte="1lk">
        Column types are used to restrict table columns with validation rules
        and provide default view settings
    </span>

    <div class="column-types-table-wrapper" rte="1ll">
        <grid
            [tableSettings]="tableSettings"
            [gridSettings]="gridSettings"
            rte="1lm"
        ></grid>
    </div>
</div>
